import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

import {
  Button,
  Container,
  Divider,
  DropdownMenuGroup,
  DropdownMenuItem,
  Icon,
  InputCheckbox,
  InputRadio,
  Notifications,
  SearchBox,
  Skeleton,
  Text,
} from "@jds/core";

import { Box, Chip } from "@mui/material";

//css
import classes from "./UpdatedShareContainer.module.css";
// Local
import JdsMenu from "../../JdsMenu";
import GreyDropDownButton from "../../Buttons/GreyDropDownButton";
import useApiHttp from "../../../../hooks/use-http";
import { useParams } from "react-router-dom";
import EmptyState from "../../../NoData/EmptyState";
import Loader from "../../Loader/Loader";
import MuiPopover from "../../MuiPopover";
import { FileUploadContext } from "../../../Layout/FileUploadLayout";
import ReindexAlert from "../../ReindexAlert/ReindexAlert";

const FilterBtn = (props) => (
  <Button
    iconLeft={"IcFilter"}
    label={props?.label || "Filter"}
    kind="tertiary"
    {...props}
  />
);

const DropdownBtn = (props) => <GreyDropDownButton {...props} />;

const DropBtn = (props) => (
  <Button
    label="Select Access"
    size="small"
    kind="secondary"
    icon={"IcChevronDown"}
    {...props}
  />
);

const ShareContainerSkeleton = () => {
  return (
    <Container direction="column" fullWidth>
      <Container
        horizontalAlign="space-between"
        verticalAlign="center"
        fullWidth
      >
        <Skeleton width={250} animated shape="heading" />
        <Skeleton width={50} animated shape="paragraph" />
      </Container>
      <Divider pad="medium" padPosition="vertical" />
      <Container
        horizontalAlign="space-between"
        verticalAlign="center"
        fullWidth
      >
        <Skeleton width={150} animated shape="paragraph" />
        <Skeleton width={100} animated shape="paragraph" />
      </Container>

      <Container
        direction="column"
        fullWidth
        gap={16}
        style={{ marginTop: "32px" }}
      >
        <Skeleton width="100%" animated shape="paragraph" />
        <Skeleton width="100%" animated shape="paragraph" />
        <Skeleton width="100%" animated shape="paragraph" />
      </Container>
    </Container>
  );
};

export default function UpdatedShareContainer(props) {
  const { id: eventId } = useParams();
  const { reindexStaus } = useContext(FileUploadContext);
  const [guestData, setGuestData] = useState();
  const [guestList, setGuestList] = useState([]);
  const [selectedGuests, setSelectedGuests] = useState([]);
  const [unSelectedGuests, setUnSelectedGuests] = useState([]);
  const [access, setAccess] = useState("NULL");
  const [downloadAccess, setDownloadAccess] = useState(false);
  const [uploadAccess, setUploadAccess] = useState(false);
  const [eventAccess, setEventAccess] = useState(null);
  const [downloadAccessFilter, setDownloadAccessFilter] = useState(null);
  const [uploadAccessFilter, setUploadAccessFilter] = useState(null);
  const [isSelectedAll, setisSelectedAll] = useState(false);
  const [accessRadio, setAccessRadio] = useState(null);
  const [downloadRadio, setDownloadRadio] = useState(null);
  const [uploadRadio, setUploadRadio] = useState(null);
  const [nameQuery, setNameQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [chipData, setChipData] = useState([]);
  const { sendRequest: getGuestDataAPI, isLoading: guestDataGetting } =
    useApiHttp();
  const { sendRequest: giveAccessAPI, isSharingAccess } = useApiHttp();
  const controller = new AbortController();
  const getGuest = () => {
    getGuestDataAPI(
      {
        url: `event-attendee/${eventId}?page=${currentPage}&size=15${
          nameQuery ? "&nameQuery=" + nameQuery : ""
        }${eventAccess ? "&eventAccess=" + eventAccess : ""}${
          downloadAccessFilter ? "&downloadAccess=" + downloadAccessFilter : ""
        }${uploadAccessFilter ? "&uploadAccess=" + uploadAccessFilter : ""}`,
        signal: controller.signal,
      },
      (data) => {
        setGuestData(data);
        setLastPage(data?.lastPage);
        if (currentPage == 0) {
          setGuestList(
            data?.data?.map((item) => ({ ...item, isSelected: isSelectedAll })),
          );
        } else {
          setGuestList((pre) => [
            ...pre,
            ...data?.data?.map((item) => ({
              ...item,
              isSelected: isSelectedAll,
            })),
          ]);
        }
        if (isSelectedAll) {
          setSelectedGuests((pre) => [
            ...pre,
            ...data?.data?.map((item) => item.id),
          ]);
        }
      },
    );
  };

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    setisSelectedAll(isChecked);
    setUnSelectedGuests([]);
    setSelectedGuests([]);

    // if (isChecked) {
    //   setSelectedGuests(guestList?.map((item) => item.id));
    // } else {
    //   setSelectedGuests([]);
    // }

    setGuestList(
      guestList?.map((item) => {
        return {
          ...item,
          isSelected: isChecked,
        };
      }),
    );
  };

  const handleCheckboxChange = (guestId, isChecked) => {
    if (isChecked) {
      setSelectedGuests((prevSelected) => {
        return [...prevSelected, guestId];
      });
      setGuestList(
        guestList?.map((item) =>
          item.id === guestId ? { ...item, isSelected: true } : item,
        ),
      );
      setUnSelectedGuests((prevSelected) => {
        return prevSelected.filter((id) => id !== guestId);
      });
    } else {
      // if (selectedGuests?.length == 1) {
      //   handleSelectAllChange({ target: { checked: false } });
      // } else {
      //   setisSelectedAll(false);
      // }
      setGuestList(
        guestList?.map((item) =>
          item.id === guestId ? { ...item, isSelected: false } : item,
        ),
      );
      setSelectedGuests((prevSelected) => {
        return prevSelected.filter((id) => id !== guestId);
      });
      setUnSelectedGuests((prevSelected) => {
        return [...prevSelected, guestId];
      });
    }
  };

  function getAccessString(access) {
    if (access === null || access === "NULL") {
      return "No Access";
    } else if (access === "FULL_ACCESS") {
      return "Full Access";
    } else if (access === "FACE_ACCESS") {
      return "Face Access";
    }
  }

  //   const handleScroll = useCallback(
  //     (e) => {
  //       const container = document?.querySelector("#share-container-scroll-div");
  //       const containerHeight = container.clientHeight;
  //       const contentHeight = container.scrollHeight;
  //       const scrollTop = container.scrollTop;

  //       // Calculate the scroll position threshold
  //       const threshold = 150; // Adjust this value as needed

  //       if (
  //         scrollTop + containerHeight + threshold >= contentHeight &&
  //         currentPage <= lastPage
  //       ) {
  //         setCurrentPage((prev) => prev + 1);
  //       }
  //     },
  //     [currentPage, lastPage]
  //   );

  const giveAccessHandler = () => {
    giveAccessAPI(
      {
        url: `event-attendee/${eventId}/share-access`,
        method: "POST",
        body: {
          access,
          downloadAccess: downloadAccess ? "APPROVED" : "REJECTED",
          uploadAccess: uploadAccess ? "APPROVED" : "NULL",
          attendeeIds: isSelectedAll ? unSelectedGuests : selectedGuests,
          isSelectedAll,
          nameQuery,
          accessFilter: eventAccess,
          downloadAccessFilter: downloadAccessFilter,
          uploadAccessFilter: uploadAccessFilter,
        },
      },
      null,
      (data) => {
        props?.onShare &&
          props.onShare({
            access,
            downloadAccess: downloadAccess ? "APPROVED" : "REJECTED",
            userIds: isSelectedAll ? unSelectedGuests : selectedGuests,
          });
        Notifications.toast.success(data?.message);

        const updatedGuestList = guestList?.map((item) =>
          isSelectedAll
            ? !unSelectedGuests.includes(item.id)
              ? {
                  ...item,
                  access,
                  downloadAccess: downloadAccess ? "APPROVED" : "REJECTED",
                  uploadAccess: uploadAccess ? "APPROVED" : null,
                  isSelected: false,
                }
              : item
            : selectedGuests.includes(item.id)
              ? {
                  ...item,
                  access,
                  downloadAccess: downloadAccess ? "APPROVED" : "REJECTED",
                  uploadAccess: uploadAccess ? "APPROVED" : null,
                  isSelected: false,
                }
              : item,
        );
        handleSelectAllChange({ target: { checked: false } });
        setGuestList(updatedGuestList);
        setSelectedGuests([]);
        setAccess("NULL");
        setUploadAccess(false);
        setDownloadAccess(false);
      },
      (err, data) => {
        Notifications.toast.error({
          id: "share-guest-error",
          title: data?.message,
        });
      },
    );
  };
  const chipSetObjAccess = {
    FACE_ACCESS: {
      id: "FACE_ACCESS",
      label: "Face access",
      type: "access",
    },
    NULL: {
      id: "NULL",
      label: "No access",
      type: "access",
    },
    FULL_ACCESS: {
      id: "FULL_ACCESS",
      label: "Full access",
      type: "access",
    },
  };
  const chipSetObjDownload = {
    APPROVED: {
      id: "DOWNLOAD-APPROVED",
      label: "With download access",
      type: "download",
    },
    REJECTED: {
      id: "REJECTED",
      label: "Without download access",
      type: "download",
    },
  };
  const chipSetObjUpload = {
    APPROVED: {
      id: "UPLOAD-APPROVED",
      label: "With upload access",
      type: "upload",
    },
    NULL: {
      id: "NULL",
      label: "Without upload access",
      type: "upload",
    },
  };
  const handleFilterChipDelete = (id, type) => {
    setChipData(chipData.filter((data) => id !== data?.id));
    setisSelectedAll(false);
    setSelectedGuests([]);
    setUnSelectedGuests([]);
    if (currentPage !== 0) {
      setCurrentPage(0);
    }
    if (type == "access") {
      setEventAccess(null);
      setAccessRadio(null);
    } else if (type == "upload") {
      setUploadAccessFilter(null);
      setUploadRadio(null);
    } else {
      console.log("hello1234==>", type);
      setDownloadAccessFilter(null);
      setDownloadRadio(null);
    }
  };

  const applyFilterAction = () => {
    setChipData([]);
    setisSelectedAll(false);
    setSelectedGuests([]);
    setUnSelectedGuests([]);
    if (currentPage !== 0) {
      setCurrentPage(0);
    }
    if (accessRadio) {
      setChipData((pre) => [...pre, chipSetObjAccess[accessRadio]]);
    }
    if (downloadRadio) {
      setChipData((pre) => [...pre, chipSetObjDownload[downloadRadio]]);
    }
    if (uploadRadio) {
      setChipData((pre) => [...pre, chipSetObjUpload[uploadRadio]]);
    }
    setEventAccess(accessRadio);
    setDownloadAccessFilter(downloadRadio);
    setUploadAccessFilter(uploadRadio);
  };
  const observerRef = useRef(null);
  const lastElementRef = useCallback(
    (node) => {
      if (guestDataGetting) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((element) => {
        if (element[0].isIntersecting && lastPage > currentPage) {
          setCurrentPage((pre) => pre + 1);
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [guestDataGetting, lastPage],
  );

  useEffect(() => {
    getGuest();
    return () => {
      controller.abort();
    };
  }, [
    currentPage,
    nameQuery,
    eventAccess,
    downloadAccessFilter,
    uploadAccessFilter,
  ]);

  if (reindexStaus?.[eventId] == "PENDING") {
    return (
      <div>
        <div>
          <Text text={`Share Photos`} appearance="heading-xs" />
        </div>
        <div
          style={{
            height: "calc(100vh - 160px)",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              maxWidth: "584px",
              marginInline: "auto",
              width: "100%",
            }}
          >
            <ReindexAlert />
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Box>
        {/* {guestList?.length > 0 && ( */}
        <Container
          horizontalAlign="space-between"
          verticalAlign="center"
          fullWidth
          // style={{ paddingInline: "40px" }}
          {...props?.headerProps}
        >
          <Box maxWidth={250}>
            <SearchBox
              label="Search "
              prefix="IcSearch"
              value={nameQuery}
              onChange={(e) => {
                setCurrentPage(0);
                setNameQuery(e.target.value);
                setisSelectedAll(false);
                setSelectedGuests([]);
                setUnSelectedGuests([]);
              }}
            />
          </Box>
          <Container gap={24} verticalAlign="center">
            <MuiPopover
              trigger={{
                component: FilterBtn,
              }}
            >
              <FilterComponent
                setAccessRadio={setAccessRadio}
                accessRadio={accessRadio}
                setDownloadRadio={setDownloadRadio}
                downloadRadio={downloadRadio}
                setUploadRadio={setUploadRadio}
                uploadRadio={uploadRadio}
                applyFilterAction={applyFilterAction}
              />
            </MuiPopover>
          </Container>
        </Container>
        {/* )} */}

        <Box my={2}>
          {chipData.length > 0 && (
            <Box my={2}>
              <Container
                fullWidth
                verticalAlign="center"
                horizontalAlign="space-between"
              >
                <Container
                  verticalAlign="center"
                  gap={16}
                  style={{ flexWrap: "wrap" }}
                >
                  {chipData.map((data) => (
                    <Chip
                      label={<Text text={data.label} appearance="body-s" />}
                      onDelete={() =>
                        handleFilterChipDelete(data?.id, data?.type)
                      }
                    />
                  ))}
                </Container>
                <Button
                  label="Clear Filter"
                  iconLeft={"IcClose"}
                  size="small"
                  kind="secondary"
                  onClick={() => {
                    if (currentPage !== 0) {
                      setCurrentPage(0);
                    }
                    setChipData([]);
                    setEventAccess(null);
                    setAccessRadio(null);
                    setDownloadAccessFilter(null);
                    setDownloadRadio(null);
                    setUploadAccessFilter(null);
                    setUploadRadio(null);
                  }}
                />
              </Container>
            </Box>
          )}
          <Divider pad="xx-small" padPosition="vertical" />
        </Box>

        {guestDataGetting && currentPage == 0 ? (
          <Loader size="small" />
        ) : guestList?.length ? (
          <div>
            <Container
              fullWidth
              horizontalAlign="space-between"
              verticalAlign="center"
              style={{ marginBottom: "32px" }}
            >
              <Box
                sx={{
                  "& .j-JDSCheckbox-horizontal-container": {
                    gap: "14px",
                  },
                }}
                onClick={() => {
                  if (
                    selectedGuests?.length &&
                    selectedGuests?.length !== guestData?.count &&
                    !isSelectedAll
                  ) {
                    handleSelectAllChange({ target: { checked: false } });
                  }
                }}
              >
                <InputCheckbox
                  label={
                    isSelectedAll
                      ? `${
                          guestData?.count - unSelectedGuests?.length
                        } Selected`
                      : selectedGuests?.length
                        ? `${selectedGuests?.length} Selected`
                        : "Select All"
                  }
                  onChange={(e) => handleSelectAllChange(e)}
                  checked={
                    isSelectedAll || selectedGuests?.length === guestData?.count
                  }
                  indeterminate={
                    selectedGuests?.length &&
                    selectedGuests?.length !== guestData?.count &&
                    !isSelectedAll
                  }
                />
              </Box>

              {/* {selectedGuests?.length && (
                )} */}
              <Container gap={16} verticalAlign="center">
                <MuiPopover
                  trigger={{
                    component: DropBtn,
                  }}
                  sx={{
                    padding: 0,
                    paddingBlock: "10px",
                    borderRadius: "10px",
                  }}
                >
                  <div className={`${classes["filter-menu"]}`}>
                    <div
                      className={`${classes["filter-item"]} ${
                        access == "NULL" && classes["filter-item-active"]
                      }`}
                      onClick={() => {
                        if (access != "NULL") {
                          setAccess("NULL");
                        }
                      }}
                    >
                      <span>
                        <Text text="No Access" color="grey-80" />
                      </span>
                    </div>

                    <div
                      className={`${classes["filter-item"]} ${
                        access == "FACE_ACCESS" && classes["filter-item-active"]
                      }`}
                      onClick={() => {
                        if (access != "FACE_ACCESS") {
                          setAccess("FACE_ACCESS");
                        }
                      }}
                    >
                      <span>
                        <Text text="Face Access" color="grey-80" />
                      </span>
                    </div>
                    <div
                      className={`${classes["filter-item"]} ${
                        access == "FULL_ACCESS" && classes["filter-item-active"]
                      }`}
                      onClick={() => {
                        if (access != "FULL_ACCESS") {
                          setAccess("FULL_ACCESS");
                        }
                      }}
                    >
                      <span>
                        <Text text="Full Access" color="grey-80" />
                      </span>
                    </div>
                    <div className={`${classes["filter-item"]}`}>
                      <span>
                        <InputCheckbox
                          onChange={(e) => {
                            setUploadAccess(e.target.checked);
                          }}
                          checked={uploadAccess}
                          label="Upload Access"
                        />
                      </span>
                    </div>
                    <div className={`${classes["filter-item"]}`}>
                      <span>
                        <InputCheckbox
                          onChange={(e) => {
                            setDownloadAccess(e.target.checked);
                          }}
                          checked={downloadAccess}
                          label="Download Access"
                        />
                      </span>
                    </div>
                  </div>
                </MuiPopover>

                <Button
                  label="Share"
                  size="small"
                  loading={isSharingAccess || false}
                  disabled={
                    isSelectedAll || selectedGuests?.length ? false : true
                  }
                  onClick={() => {
                    giveAccessHandler();
                  }}
                />
              </Container>
            </Container>
            <Box
              id="share-container-scroll-div"
              className="custom-scrollbar"
              fullWidth
              sx={{
                maxHeight: props?.maxHeight || "250px",
                overflow: "auto",
                pr: "12px",
              }}
              // onScroll={(e) => {
              //   handleScroll(e);
              // }}
            >
              {guestList?.map((item, i) => {
                return (
                  <>
                    <Box
                      width={"100%"}
                      key={i}
                      ref={i + 1 == guestList?.length ? lastElementRef : null}
                    >
                      <Container
                        fullWidth
                        verticalAlign="center"
                        horizontalAlign="space-between"
                      >
                        <Box
                          sx={{
                            "& .j-JDSCheckbox-horizontal-container": {
                              gap: "14px",
                            },
                            "& .j-JDSCheckbox-label-jds-text": {
                              fontFamily: "var(--font-families-body-m)",
                              color: "var(--color-primary-gray)",
                            },
                          }}
                        >
                          <InputCheckbox
                            label={`${item?.firstName || ""} ${
                              item?.lastName || ""
                            }`}
                            checked={item?.isSelected}
                            onChange={(e) =>
                              handleCheckboxChange(item?.id, e.target.checked)
                            }
                          />
                        </Box>
                        <Container direction="row" gap={12}>
                          <Container verticalAlign="center" gap={4}>
                            <Icon ic="IcPhoto" size="s" />
                            <Text
                              appearance="body-xs"
                              text={getAccessString(item?.access)}
                              color="primary-grey-80"
                            />
                          </Container>
                          <Container verticalAlign="center" gap={4}>
                            <Icon
                              size="s"
                              ic={
                                item?.uploadAccess === "APPROVED"
                                  ? "IcSuccess"
                                  : "IcError"
                              }
                              color={
                                item?.uploadAccess === "APPROVED"
                                  ? "success"
                                  : "error"
                              }
                            />
                            <Text
                              appearance="body-xs"
                              text={"Upload Access"}
                              color="primary-grey-80"
                            />
                          </Container>
                          <Container verticalAlign="center" gap={4}>
                            <Icon
                              size="s"
                              ic={
                                item?.downloadAccess === "APPROVED"
                                  ? "IcSuccess"
                                  : "IcError"
                              }
                              color={
                                item?.downloadAccess === "APPROVED"
                                  ? "success"
                                  : "error"
                              }
                            />
                            <Text
                              appearance="body-xs"
                              text={"Download Access"}
                              color="primary-grey-80"
                            />
                          </Container>
                        </Container>
                      </Container>
                      {guestList?.length - 1 !== i && (
                        <Box my={2}>
                          <Divider pad="none" padPosition="vertical" />
                        </Box>
                      )}
                    </Box>
                  </>
                );
              })}
              {guestDataGetting && currentPage !== 0 && <Loader size="small" />}
            </Box>
            {/* <Container
                horizontalAlign="center"
                style={{ marginTop: "32px" }}
                fullWidth
              >
                <Button
                  label="Share"
                  size="large"
                  loading={isSharingAccess || false}
                  disabled={selectedGuests?.length ? false : true}
                  onClick={() => giveAccessHandler()}
                />
              </Container> */}
          </div>
        ) : (
          <Box mt={4}>
            <EmptyState title="No guests found!" action={false} />
          </Box>
        )}
      </Box>
    </>
  );
}

const FilterComponent = ({
  setAccessRadio = () => {},
  accessRadio = null,
  setDownloadRadio = () => {},
  downloadRadio = null,
  setUploadRadio = () => {},
  uploadRadio = null,
  applyFilterAction = () => {},
  close = () => {},
}) => {
  return (
    <div
      style={{
        padding: "10px",
      }}
    >
      <div>
        <div className={`${classes["filter-head"]}`}>
          <Text text="Filter by image access" />
        </div>
        <div className={`${classes["filter-block"]}`}>
          <div className={`${classes["filter-ele"]}`}>
            <InputRadio
              size="small"
              value="NULL"
              onClick={(e) => {
                setAccessRadio(e.target.value);
              }}
              checked={accessRadio == "NULL" ? true : false}
            />
            <span
              onClick={(e) => {
                setAccessRadio("NULL");
              }}
            >
              <Text text="No access" color="primary_grey_80" />
            </span>
          </div>
          <div className={`${classes["filter-ele"]}`}>
            <InputRadio
              size="small"
              value="FACE_ACCESS"
              onClick={(e) => {
                setAccessRadio(e.target.value);
              }}
              checked={accessRadio == "FACE_ACCESS" ? true : false}
            />
            <span
              onClick={(e) => {
                setAccessRadio("FACE_ACCESS");
              }}
            >
              <Text text="Face access" color="primary_grey_80" />
            </span>
          </div>
          <div className={`${classes["filter-ele"]}`}>
            <InputRadio
              size="small"
              value="FULL_ACCESS"
              onClick={(e) => {
                setAccessRadio(e.target.value);
              }}
              checked={accessRadio == "FULL_ACCESS" ? true : false}
            />
            <span
              onClick={(e) => {
                setAccessRadio("FULL_ACCESS");
              }}
            >
              <Text text="Full access" color="primary_grey_80" />
            </span>
          </div>
        </div>
      </div>
      <div>
        <div className={`${classes["filter-head"]}`}>
          <Text text="Filter by upload access" />
        </div>
        <div className={`${classes["filter-block"]}`}>
          <div className={`${classes["filter-ele"]}`}>
            <InputRadio
              size="small"
              value="APPROVED"
              onClick={(e) => {
                setUploadRadio(e.target.value);
              }}
              checked={uploadRadio == "APPROVED" ? true : false}
            />
            <span
              onClick={(e) => {
                setUploadRadio("APPROVED");
              }}
            >
              <Text text="With upload access" color="primary_grey_80" />
            </span>
          </div>
          <div className={`${classes["filter-ele"]}`}>
            <InputRadio
              size="small"
              value="NULL"
              onClick={(e) => {
                setUploadRadio(e.target.value);
              }}
              checked={uploadRadio == "NULL" ? true : false}
            />
            <span
              onClick={(e) => {
                setUploadRadio("NULL");
              }}
            >
              <Text text="Without upload access" color="primary_grey_80" />
            </span>
          </div>
        </div>
      </div>
      <div>
        <div className={`${classes["filter-head"]}`}>
          <Text text="Filter by download access" />
        </div>
        <div className={`${classes["filter-block"]}`}>
          <div className={`${classes["filter-ele"]}`}>
            <InputRadio
              size="small"
              value="APPROVED"
              onClick={(e) => {
                setDownloadRadio(e.target.value);
              }}
              checked={downloadRadio == "APPROVED" ? true : false}
            />
            <span
              onClick={(e) => {
                setDownloadRadio("APPROVED");
              }}
            >
              <Text text="With download access" color="primary_grey_80" />
            </span>
          </div>
          <div className={`${classes["filter-ele"]}`}>
            <InputRadio
              size="small"
              value="REJECTED"
              onClick={(e) => {
                setDownloadRadio(e.target.value);
              }}
              checked={downloadRadio == "REJECTED" ? true : false}
            />
            <span
              onClick={(e) => {
                setDownloadRadio("REJECTED");
              }}
            >
              <Text text="Without download access" color="primary_grey_80" />
            </span>
          </div>
        </div>
      </div>
      <div style={{ marginTop: "16px" }}>
        <Button
          fullWidth
          kind="primary"
          size="small"
          label="Apply Filter"
          onClick={() => {
            applyFilterAction();
            close();
          }}
        />
      </div>
    </div>
  );
};
